// msalConfig.ts
import { type Configuration, LogLevel } from '@azure/msal-browser'

import { MSAL_CLIENT_ID, MSAL_POST_LOGOUT_REDIRECT_URI, MSAL_REDIRECT_URI, MSAL_TENANT_ID } from '../env'

// Ensure environment variables exist with default values for development
const CLIENT_ID = MSAL_CLIENT_ID
const TENANT_ID = MSAL_TENANT_ID
const REDIRECT_URI = MSAL_REDIRECT_URI
const POST_LOGOUT_REDIRECT_URI = MSAL_POST_LOGOUT_REDIRECT_URI
const AUTHORITY = `https://login.microsoftonline.com/${TENANT_ID}`

export const API_SCOPE = `api://${CLIENT_ID}/access_as_user`

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI
    // MSAL v5: navigateToLoginRequestUrl removed. Default behavior now navigates
    // back to the original request URL after login. Use onRedirectNavigate to opt out.
  },
  cache: {
    cacheLocation: 'localStorage'
    // MSAL v5: storeAuthStateInCookie removed from CacheOptions (was already the default: false).
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message)

            return
          case LogLevel.Info:
            console.info(message)

            return
          case LogLevel.Verbose:
            console.debug(message)

            return
          case LogLevel.Warning:
            console.warn(message)

            return
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Error
    }
    // MSAL v5: windowHashTimeout, iframeHashTimeout, and loadFrameTimeout removed from
    // BrowserSystemOptions. Closest v5 equivalents: redirectNavigationTimeout (redirect flow),
    // iframeBridgeTimeout and popupBridgeTimeout (silent/popup flows via BroadcastChannel).
    // Previous values (windowHashTimeout: 60s, iframeHashTimeout: 6s) were defaults, so no
    // behavior change expected. loadFrameTimeout: 0 was non-default but no longer has an equivalent.
  }
}

export const loginRequest = {
  scopes: ['user.read']
}

export const userDataLoginRequest = {
  scopes: ['user.read']
}

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
}
